import * as cx from 'classnames';
import range from 'lodash-es/range';
import { BlogPostCommentCreateFormFactory } from 'mk2/apps/blogs/components/BlogPostCommentCreateForm';
import Comment, { CommentPlaceholder } from 'mk2/apps/blogs/components/Comment';
import { MessageFormFactory } from 'mk2/apps/blogs/components/MessageForm';
import { PHOTOBLOG_POST_TEXTAREA } from 'mk2/apps/blogs/helpers';
import { CommentEntity } from 'mk2/apps/blogs/schemas';
import { CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import Complaint from 'mk2/containers/Complaint/Complaint';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import * as React from 'react';
import styles from './CommentList.mscss';

interface OwnProps {
    comments: CommentEntity[];
    requestUser: UserEntity;
    requestUserPermissions: string[];
    isIOS: boolean;
    mobile: boolean;
    moderators: UserEntity[];
    canAdd: boolean; // has add new comment form
    postId: number;
    postKey: string;
    highlightedId: number;
    inGroups?: boolean;
    initialValues: CommentFormData;
    inPrivateGroup?: boolean;
    loadingState: LoadingState;
    complaintsOpened: boolean[];

    location?: string;
    count?: number;

    onLike(id: number);
    onCreate(commentFd: CommentFormData);
    onReply(username: string);
    onDelete(commentId: number);
    onReport(entityType: string, commentId: number);
    onSendHeart();
    onToggleMenuMore?(id: number);
}

export default class CommentList extends React.PureComponent<OwnProps> {

    public static defaultProps: Partial<OwnProps> = {
        count: 3,
    };

    private messageFormTextarea: HTMLTextAreaElement;
    private BlogPostCommentCreateForm = BlogPostCommentCreateFormFactory(PHOTOBLOG_POST_TEXTAREA(this.props.postId));
    private MessageForm = MessageFormFactory(PHOTOBLOG_POST_TEXTAREA(this.props.postId));

    public render() {
        const {
            comments, canAdd, requestUser, requestUserPermissions, onCreate, inGroups, initialValues,
            inPrivateGroup, isIOS, count, highlightedId, mobile, postKey, loadingState, complaintsOpened,
            onSendHeart, location, moderators, onDelete, onReport, onToggleMenuMore,
        } = this.props;

        const MessageForm = this.MessageForm;
        const BlogPostCommentCreateForm = this.BlogPostCommentCreateForm;

        return (
            <div className={styles.CommentList}>
                <ul
                    className={cx(
                        styles.CommentList__list,
                        inGroups ? styles['CommentList__list--inGroups'] : styles['CommentList__list--inBlogs'],
                    )}
                >
                    { isSuccess(loadingState) || comments.length ?
                        (comments.map((comment, index) => (
                            <div key={comment.id} className={cx(complaintsOpened[index] && styles['CommentList__list--reporting'])}>
                                <Complaint
                                    entity="photoblog-comment"
                                    id={comment.id}
                                    inForum={false}
                                />
                                <Comment
                                    key={comment.id}
                                    inForum={false}
                                    inGroups={inGroups}
                                    comment={comment}
                                    highlighted={comment.id === highlightedId}
                                    isMobile={mobile}
                                    requestUser={requestUser}
                                    requestUserPermissions={requestUserPermissions}
                                    hasBodyHiddenText={false}
                                    hasBodyDeletedStatus={false}
                                    hasFooterLike
                                    hasFooterReply
                                    hasMenu
                                    hasMenuReport={(inGroups && !inPrivateGroup) ? true : false}
                                    hasMenuEdit={false}
                                    hasMenuDelete={inGroups ? true : false}
                                    moderators={moderators}
                                    onReply={this.onReply}
                                    onDelete={onDelete}
                                    onReport={onReport}
                                    onSendHeart={onSendHeart}
                                    onToggleMenuMore={onToggleMenuMore}
                                    hasMenuMoveUp={false}
                                    location={location}
                                />
                            </div>
                        ))) : (
                            range(count).map((index) => <CommentPlaceholder key={index} />)
                        )
                    }
                </ul>
                {canAdd ? (
                    inGroups ? (
                        <div>
                            <BlogPostCommentCreateForm
                                initialValues={initialValues}
                                isDesktop={!mobile}
                                isIOS={isIOS}
                                onSave={onCreate}
                                requestUserPermissions={requestUserPermissions}
                                textareaRef={this.setTextareaRef}
                            />
                        </div>
                    ) : (
                        <div className={styles.CommentList__messageForm}>
                            <MessageForm
                                requestUser={requestUser}
                                postKey={postKey}
                                initialValues={initialValues}
                                onSend={onCreate}
                                textareaRef={this.setTextareaRef}
                            />
                        </div>
                    )
                ) : null
                }
            </div>
        );
    }

    private onReply = (username) => {
        this.props.onReply(username);
        this.messageFormTextarea.focus();
    };

    private setTextareaRef = (r) => this.messageFormTextarea = r;
}
